module.exports = __webpack_public_path__ + "img/card-back.9ec53356.jpg";